export const STEP_IDS = {
  BEFORE_YOU_BEGIN: 'before-you-begin',
  CREATE_BOT_USER: 'create-bot-user',
  GRANT_ACCESS: 'grant-access',
  SELECT_REPOSITORIES: 'select-repositories',
  CHECK_CONNECTION: 'check-connection',
  ENABLE_QODO: 'enable-qodo',
};

export const FORM_IDS = {
  GRANT_ACCESS: 'grant-access-form',
  SELECT_REPOSITORIES: 'select-repositories-form',
} as const;

export const QODO_LOGO_DOWNLOAD_URL =
  '/images/github-installation/qodo-logo.png';

export const ENABLE_QODO_TRANSLATION_KEY =
  'dialogs.bitbucket-installation.enable-qodo';
